import styled from 'styled-components';

export const Wrapper = styled.div`
  min-width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  gap: 1rem;
  flex-direction: column;

  padding: 0 5px 0 5px;
  background-color: white;

  @media (max-width: 520px) {
    padding: 0;
  }
`;

export const HeaderWrapper = styled.div`
  display: grid;
`;

export const GraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  height: 100%;
`;
